import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import {Field, reduxForm, getFormValues} from 'redux-form';
import * as validateRule from '../../validateRule';
import Grid from '@mui/material/Grid';
import {connect} from 'react-redux';

import LoginCommon, {commonStyles, renderTextField} from './loginCommon';
import {PositiveButton} from '../../atoms/Buttons/PositiveButton';
import withRouter from '../../organisms/withRouter';
import {commonOperations} from '../../../reducks/common/index';
import {authOperations} from '../../../reducks/auth/index';
import appConfig from '@/config';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      information: '',
      isLoadingInformation: true,
    };
  }
  doLogin = async () => {
    const {
      doShowMessage,
      getLoginInfo,
      loginAction,
      navigate,
    } = this.props;

    const result = await loginAction();
    if (result === 'OK') {
      try {
        // ログイン関連情報一括取得
        const userInfo = await getLoginInfo();

        // トップ画面へ遷移
        if (userInfo) {
          navigate('/');
        }
      } catch (err) {
        console.log('Login failure caused by', err);
      }
    } else if (result === 'REDIRECT_NEW_PASSWORD') {
      // 仮パスワードログインのため、パスワード変更画面へリダイレクト
      const dialog = {
        message: 'TKSCS00018I',
        action: () => {
          navigate('/password');
        },
      };
      doShowMessage(dialog);
    } else if (result === 'RESET_REQUIRE') {
      const dialog = {
        message: {
          id: 'TKSCZ00021I',
          values: [appConfig['MAIL_DOMAIN']],
        },
      };
      doShowMessage(dialog);
    } else if (result === 'NO_LOGIN') {
      const dialog = {
        message: 'TKSCZ00019E',
      };
      doShowMessage(dialog);
    } else {
      const dialog = {
        message: 'TKSCS00001S',
      };
      doShowMessage(dialog);
    }
  };

  render() {
    const {classes, handleSubmit} = this.props;

    return (
      <LoginCommon pageTitle="ログイン">
        <Grid container justifyContent="center">
          <Grid item xs={8}>
            <Field
              name="username"
              label="ID"
              className={classes.textField}
              required={true}
              margin="normal"
              variant="outlined"
              component={renderTextField}
              autoComplete="username"
              type="text"
              validate={[validateRule.required]}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={8}>
            <Field
              name="password"
              label="パスワード"
              type="password"
              className={classes.textField}
              required={true}
              margin="normal"
              variant="outlined"
              component={renderTextField}
              autoComplete="current-password"
              validate={[validateRule.required]}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <PositiveButton
              onClick={handleSubmit(this.doLogin)}
              variant="contained"
              className={classes.button}
              size="large"
              type="submit"
            >
              <span>ログイン</span>
            </PositiveButton>
          </Grid>
          <span className={classes.copyright} style={{margin: '2rem 0px 0px 0px'}}>
            {appConfig.copyright}
          </span>
        </Grid>
      </LoginCommon>
    );
  }
}

const FORM_NAME = 'Login';

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  doShowMessage: PropTypes.func,
  handleSubmit: PropTypes.func,
  loginAction: PropTypes.func,
  getLoginInfo: PropTypes.func,
  navigate: PropTypes.func,
};

const mapDispatchToProps = {
  loginAction: authOperations.doLoginOperation,
  getLoginInfo: commonOperations.doGetLoginInfo,
  doShowMessage: commonOperations.doShowMessage,
};

const mapStateToProps = (state) => ({
});

Login = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Login));
export default withStyles(commonStyles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Login)),
);
